<script setup lang="ts">
type Props = {
  imgUrl: string;
  text: string;
  width?: number;
};

const props = withDefaults(defineProps<Props>(), {
  width: 80,
});
</script>

<template>
  <div
    role="group"
    class="flex py-3 px-4 gap-5 items-center bg-grey-lighten-5 rounded-lg"
    aria-label="Image and description"
  >
    <div
      class="overflow-hidden !rounded-sm shrink-0"
      :style="{ width: `${props.width}px`, height: `${props.width}px` }"
    >
      <v-img cover alt="Tip image" class="w-full h-full" :src="props.imgUrl" />
    </div>

    <p class="text-body-4 text-af-grey-700">
      {{ props.text }}
    </p>
  </div>
</template>
